export enum FilterGroupType {
  RecordType = 'RecordType',
  FilterDomains = 'FilterDomains',
  EndingToday = 'AuctionsEndingToday',
  WithBids = 'AuctionsWithBids',
  KeywordPlacement = 'Placement',
  CharacterLength = 'Length',
  PriceRange = 'HighBid',
  Reserve = 'Reserve',
  TLD = 'Tld',
  ExpirationDate = 'ExpirationDate'
}
